export default "__VITE_ASSET__84b67c31__"